import RacingOddsComparisonTable from './RacingOddsComparisonTable.vue';
import state from './state/RacingOddsComparisonTable';

// We are intentionally exposing components that *may* be required by the bundle-consumer
// Source-code-consumers like odds.com.au can directly import modules, so are not affected
export default {
  RacingOddsComparisonTable,
  state,
};
